import React, { Component } from 'react';
import './NavigationMobile.css';
import { Link } from 'react-router-dom';
import { getRegionURLString } from "./Helper/functions";


class NavigationMobile extends Component {

	constructor(props) {
		super(props);

		this.state = {
			showMobileNavi: 'inactive',
			showRegions: 'inactive'
		}
	}

	onClickMobileNavi(event) {
		let active = (this.state.showMobileNavi == 'inactive') ? 'active' : 'inactive';
		this.setState({ showMobileNavi: active });
		if(this.state.showRegions == 'active') {
			this.onClickSchoolHolidays();
		}
	}

	onClickSchoolHolidays(event) {
		let active = (this.state.showRegions == 'inactive') ? 'active' : 'inactive';
		this.setState({ showRegions: active });
	}

	render() {

		return (
			<div className={"NavigationMobile " + this.state.showMobileNavi}>
				<div className="NavigationMobile-menu-btn" onClick={()=>this.onClickMobileNavi('burger-icon')}>
					<span>Navigation</span>
				</div>
				<nav className="NavigationMobile-nav">
					<div className="NavigationMobile-nav-main">
						<Link to={'/' + this.props.year + '/'} onClick={()=>this.onClickMobileNavi()}>Feiertage</Link>
						<a href="#" onClick={()=>this.onClickSchoolHolidays()}>Schulferien</a>
						<ul className={"NavigationMobile-nav-main-schoolHolidays " + this.state.showRegions}>
							<li><Link to={'/' + this.props.year + '/schulferien/' + getRegionURLString('B') + '/'} onClick={()=>this.onClickMobileNavi()}>Burgenland</Link></li>
							<li><Link to={'/' + this.props.year + '/schulferien/' + getRegionURLString('K') + '/'} onClick={()=>this.onClickMobileNavi()}>Kärnten</Link></li>
							<li><Link to={'/' + this.props.year + '/schulferien/' + getRegionURLString('NÖ') + '/'} onClick={()=>this.onClickMobileNavi()}>Niederösterreich</Link></li>
							<li><Link to={'/' + this.props.year + '/schulferien/' + getRegionURLString('OÖ') + '/'} onClick={()=>this.onClickMobileNavi()}>Oberösterreich</Link></li>
							<li><Link to={'/' + this.props.year + '/schulferien/' + getRegionURLString('S') + '/'} onClick={()=>this.onClickMobileNavi()}>Salzburg</Link></li>
							<li><Link to={'/' + this.props.year + '/schulferien/' + getRegionURLString('St') + '/'} onClick={()=>this.onClickMobileNavi()}>Steiermark</Link></li>
							<li><Link to={'/' + this.props.year + '/schulferien/' + getRegionURLString('T') + '/'} onClick={()=>this.onClickMobileNavi()}>Tirol</Link></li>
							<li><Link to={'/' + this.props.year + '/schulferien/' + getRegionURLString('V') + '/'} onClick={()=>this.onClickMobileNavi()}>Vorarlberg</Link></li>
							<li><Link to={'/' + this.props.year + '/schulferien/' + getRegionURLString('W') + '/'} onClick={()=>this.onClickMobileNavi()}>Wien</Link></li>
						</ul>
					</div>
					<div className="NavigationMobile-nav-meta">
						<a href="/impressum/">Impressum</a>
						<span>Share on</span>
						<div className="NavigationMobile-nav-meta-social">
							<a target="_blank" href={'https://www.facebook.com/sharer.php?u=' + document.URL} title="Share on Facebook" onClick={()=>this.fireGoogleAnalyticsEvent('Social', 'Facebook', document.URL)}>
								<img src="/icons/facebook-white.svg" alt="Auf Facebook teilen" />
							</a>
							<a target="_blank" href={'https://twitter.com/intent/tweet?url=' + document.URL} title="Share on Twitter" onClick={()=>this.fireGoogleAnalyticsEvent('Social', 'Twitter', document.URL)}>
								<img src="/icons/twitter-white.svg" alt="Auf Twitter teilen" />
							</a>
						</div>
					</div>
				</nav>

			</div>
		);
	}
}


export default NavigationMobile;



// WEBPACK FOOTER //
// ./src/components/NavigationMobile.js